/** @jsxImportSource @emotion/react */
import { css, Global } from '@emotion/react';
import React, { useState } from 'react';
import giveaway from "src/assets/images/icon-giveaway.svg";

const globalStyles = css`
  @import 'https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;700&display=swap';

  .k03-giveaway {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    padding: 16px 20px;
    color: #6A0098;
    text-align: center;
    font-family: 'Red Hat Display';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-decoration: none;
    word-spacing: 1.5px;
    background: #C5F7E2;
    box-shadow: 0px -1px 43.1px 0px rgba(0, 0, 0, 0.08);
    -webkit-backdrop-filter: blur(20.5px);
    backdrop-filter: blur(20.5px);
    height: 50px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    cursor: pointer;
    z-index: 100;
  }

  .k03-giveaway:hover {
    color: #8E00CC;
    opacity: 1;
  }

  .k03-giveaway .k03-giveaway-mobile {
    display: none;
  }

  .k03-giveaway .k03-giveaway-title {
    text-transform: uppercase;
    letter-spacing: 1.68px;
    word-spacing: 0;
  }

  .k03-giveaway .k03-giveaway-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url(${giveaway}) no-repeat 0 0;
    margin-right: 16px;
  }

  @media (max-width: 1200px) {
    .k03-giveaway {
      padding: 13px 10px;
      height: 44px;
    }

    .k03-giveaway .k03-giveaway-desktop {
      display: none;
    }

    .k03-giveaway .k03-giveaway-mobile {
      display: block;
    }

    .k03-giveaway .k03-giveaway-icon {
      margin-right: 12px;
    }
  }

  .k03-giveaway-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 101;
    background-color: rgba(50, 50, 50, 0.55);
    transition: all 0.5s ease-in-out;
  }

  .k03-giveaway-modal-content {
    width: 530px;
    font-family: 'Red Hat Display';
    font-size: 14px;
    line-height: 20px;
    color: #323232;
    background-color: #FFFFFF;
    border-radius: 16px;
    max-height: 92%;
    position: fixed;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
    z-index: 2;
    padding: 48px 72px 48px;
    overflow: auto;
    box-shadow: 0 4px 40px rgba(0, 0, 0, 0.06);
  }

  @media (max-width: 767px) {
    .k03-giveaway-modal-content {
      padding: 32px 24px;
    }
  }

  @media (max-width: 576px) {
    .k03-giveaway-modal-content {
      width: 90%;
    }
  }

  .k03-giveaway-modal-img {
    margin-bottom: 10px;
  }

  .k03-giveaway-modal-img img {
    vertical-align: top;
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 767px) {
    .k03-giveaway-modal-img {
      max-width: 180px;
      margin: 0 auto 10px;
    }
  }

  .k03-giveaway-modal-title {
    display: block;
    margin-bottom: 10px;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
  }

  @media (max-width: 767px) {
    .k03-giveaway-modal-title {
      font-size: 24px;
      margin: 0 -10px 10px;
    }
  }

  .k03-giveaway-modal p {
    margin: 0 0 20px;
  }

  @media (max-width: 767px) {
    .k03-giveaway-modal p.small {
      font-size: 14px;
    }
  }

  .k03-giveaway-modal-btn {
    display: inline-block;
    vertical-align: top;
    padding: 10px 18px;
    font-size: 18px;
    line-height: 20px;
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    color: #6A0098;
    border: 2px solid #6A0098;
    background-color: transparent;
    border-radius: 8px;
    white-space: nowrap;
    transition: all 0.15s ease-in-out;
  }

  .k03-giveaway-modal-btn:hover {
    color: #FFFFFF;
    background-color: #8E00CC;
    border-color: #8E00CC;
  }

  .k03-giveaway-modal-btn:focus {
    color: #FFFFFF;
    background-color: #B200FF;
    border-color: #B200FF;
  }

  .k03-giveaway-modal-btn:active {
    color: #470066;
    background-color: transparent;
    border-color: #470066;
  }

  .k03-giveaway-modal-text {
    padding: 8px; 
    border-radius: 8px; 
    background: var(--Text-Text-6, #F2F2F2); 
    margin-bottom: 12px;

    p:last-child{margin-bottom: 0;}
  }

  .k03-giveaway-modal p a {
    color: #323232;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
      color: #6A0098;
    }
  }
`;

export const HeaderWidgetGiveaway: React.FC = () => {
  const [modalVisible, setModalVisible] = useState(false);

  const showGiveawayModal = () => {
    setModalVisible(true);
  };

  const closeGiveawayModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Global styles={globalStyles} />
      <a className="k03-giveaway" onClick={showGiveawayModal}>
        {/* <i className="k03-giveaway-icon"></i> */}
        <div className="k03-giveaway-desktop">
          <span className="k03-giveaway-title"><strong>HZZO diže cijenu na 15€</strong> - raskid bez penala do 31.1.</span>
        </div>
        <div className="k03-giveaway-mobile">
          <strong>RASKID HZZO POLICE BEZ PENALA</strong>
        </div>
      </a>

      {modalVisible && (
        <div id="giveawayModal" className="k03-giveaway-modal" onClick={closeGiveawayModal}>
          <div className="k03-giveaway-modal-content" onClick={(e) => e.stopPropagation()}>
            {/* <div className="k03-giveaway-modal-img">
              <img src="https://kompare.hr/wp-content/uploads/2024/02/Mokka-Stamp-2.webp" alt="Opel Mokka" />
            </div> */}
            <strong className="k03-giveaway-modal-title">Raskid HZZO police bez penala samo do kraja mjeseca</strong>

            <div className="k03-giveaway-modal-text">
              <p>HZZO s 1.2. podiže cijenu dopunskog osiguranja na 15€ mjesečno.</p>

              <p><strong>Svi osiguranici imaju pravo raskida bez penala do 31.1.2026.</strong></p>

              <p>Želite raskinuti HZZO policu? Ispunite <a href="https://kompare.hr/wp-content/uploads/2026/01/HZZO-Zahtjev-za-raskid-ugovora.pdf" target="_blank" rel="noopener noreferrer">obrazac na linku</a> i pošaljite ga na dopunsko-osiguranje@hzzo.hr uz napomenu <em>“Zbog promjene cijene police”</em>.</p>
            </div>

            <p style={{ marginBottom: '12px' }}><strong>Kome se isplati raskinuti HZZO policu?</strong></p>

            <p>HZZO polica i police privatnih osiguravatelja <strong>imaju ista, zakonski propisana pokrića</strong>. Razlika je samo u cijeni.</p>

            <p><strong>Za osobe mlađe od 60 godina</strong> police privatnih osiguranja su povoljnije. Cijene, ovisno o dobi, kreću <strong>već od 6€ mjesečno</strong>. Ušteda može biti do 108€ godišnje.</p>

            <div style={{ textAlign: 'center' }}>
              <a className="k03-giveaway-modal-btn" onClick={closeGiveawayModal}>Zatvori</a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};